export enum TrackingIndicatorCircleTextStates {
    UNCOMPLETED = 'UNCOMPLETED',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
}
